import axios from "@/axios-auth";
import { Notify } from "quasar";

const state = {
  OpenDialogEditarSettings: false,
  OpenDialogAgendarMensagem: false,
  OpenDialogCancelarFilas: false,
  OpenDialogImportarTemplates: false,
  OpenDialogSegundaVia: false,
  loadingWppMessagesList: false,
  DetalhesAgendado: "",
  wppMessagesList: [],
  status: {
    label: "Na Fila",
    index: 0,
  },
  filas: [],
  pagingWhatsapp: {
    finder: null,
    page: 0,
    current: 0,
    count: 0,
    perPage: 0,
    prevPage: false,
    nextPage: true,
    pageCount: 0,
    sort: null,
    direction: false,
    limit: null,
    sortDefault: false,
    directionDefault: false,
    scope: null
  },
  filtrosWhatsapp: {
    page: 0,
    status: 2,
  },
  conexao: "",
  tipoWhatsapp: "",
  // Canal da DouraSat gravado nas configuracoes: 'whatsapp' e a API oficial
  // (so envia template aprovado) e 'whatsapp_web' e a nao oficial.
  canalDourasat: "",
  configWhatsappCarregada: false
};

const mutations = {
  OpenDialogEditarSettings: (state, userData) => {
    state.OpenDialogEditarSettings = userData;
  },
  OpenDialogAgendarMensagem: (state, userData) => {
    state.OpenDialogAgendarMensagem = userData;
  },
  OpenDialogCancelarFilas: (state, userData) => {
    state.OpenDialogCancelarFilas = userData;
  },
  OpenDialogImportarTemplates: (state, userData) => {
    state.OpenDialogImportarTemplates = userData;
  },
  OpenDialogSegundaVia: (state, aberto) => {
    state.OpenDialogSegundaVia = aberto;
  },
  DetalhesAgendado: (state, userData) => {
    state.DetalhesAgendado = userData;
  },
  setWppMessagesList: (state, userData) => {
    state.wppMessagesList = userData;
  },
  setStatus: (state, userData) => {
    state.status = userData;
  },
  setLoadingWppMessagesList: (state, userData) => {
    state.loadingWppMessagesList = userData;
  },
  setPagingWhatsapp: (state, userData) => {
    state.pagingWhatsapp = userData;
  },
  setFiltrosWhatsapp: (state, userData) => {
    state.filtrosWhatsapp = userData;
  },
  setFilas: (state, userData) => {
    state.filas = userData;
  },
  conexao: (state, userData) => {
    state.conexao = userData;
  },
  tipoWhatsapp: (state, userData) => {
    state.tipoWhatsapp = userData;
  },
  canalDourasat: (state, userData) => {
    state.canalDourasat = userData;
  },
  configWhatsappCarregada: (state, userData) => {
    state.configWhatsappCarregada = userData;
  }
};

const actions = {
  //change: fazer função para verificar se usuário tem permissão pro aplicativo ou não

  // Tipo e canal só chegavam na store como efeito colateral do modal de
  // configurações, que existe apenas na tela de WhatsApp. A tela de Parâmetros
  // precisa da mesma informação para decidir se mostra a publicação na DouraSat.
  // Falha (inclusive sem permissão) deixa os valores vazios: quem depende deles
  // esconde o botão, em vez de oferecer uma ação que o backend recusa.
  carregarConfigWhatsapp({ commit, state }, forcar = false) {
    if (state.configWhatsappCarregada && !forcar) {
      return Promise.resolve();
    }

    return axios
      .get("/whatsapp/config")
      .then(res => {
        if (!res.data || !res.data.success || !res.data.atual) return;

        commit("tipoWhatsapp", res.data.atual.whatsapps_tipo);
        commit("canalDourasat", res.data.atual.whatsapps_dourasat_canal);
        commit("configWhatsappCarregada", true);
      })
      .catch(() => {});
  },

  listarWppMessagesList({ commit, state, dispatch }, userData = {}) {
    if (userData.atualizar) {
      dispatch("resetFiltrosWhatsapp");
      dispatch("resetPagingWhatsapp");
      commit("setWppMessagesList", []);
    }
    if (state.loadingWppMessagesList) return;
    if (!state.pagingWhatsapp.nextPage) return;

    commit("setLoadingWppMessagesList", true);

    let dados = state.filtrosWhatsapp;
    dados.page += 1;

    axios
      .get('/whatsapp', {
        params: dados,
      })
      .then(res => {
        commit("setLoadingWppMessagesList", false);

        if (!res.data.success) {
          Notify.create({
            message: res.data.message,
            color: "red",
            position: "top-right"
          });
          return;
        }

        const wppMessagesList = [...state.wppMessagesList, ...res.data.whatsapps];

        commit("setWppMessagesList", wppMessagesList);
        commit("setPagingWhatsapp", res.data.paging);
      }).catch(err => {
        Notify.create({
          message: "Houve um erro ao listar a filas de mensages!",
          color: "red",
          position: "top-right"
        });
        commit("setLoadingWppMessagesList", false);
        commit("hasWhatsapp", false);
      });
  },
  resetPagingWhatsapp: ({ commit }) => {
    commit("setPagingWhatsapp", {
      finder: null,
      page: 0,
      current: 0,
      count: 0,
      perPage: 0,
      prevPage: false,
      nextPage: true,
      pageCount: 0,
      sort: null,
      direction: false,
      limit: null,
      sortDefault: false,
      directionDefault: false,
      scope: null
    });
  },
  resetFiltrosWhatsapp: ({ commit, status }) => {
    commit("setFiltrosWhatsapp", {
      page: 0,
      status: state.status.index,
    });
  },
  abrirDialogCancelarFilas: ({ commit }, userData) => {
    commit("OpenDialogCancelarFilas", true);
    commit("setFilas", userData);
  },
};

const getters = {
  wppMessagesList: state => {
    return state.wppMessagesList;
  },
  status: state => {
    return state.status;
  },
  OpenDialogEditarSettings: state => {
    return state.OpenDialogEditarSettings;
  },
  OpenDialogAgendarMensagem: state => {
    return state.OpenDialogAgendarMensagem;
  },
  OpenDialogCancelarFilas: state => {
    return state.OpenDialogCancelarFilas;
  },
  OpenDialogImportarTemplates: state => {
    return state.OpenDialogImportarTemplates;
  },
  OpenDialogSegundaVia: state => {
    return state.OpenDialogSegundaVia;
  },
  DetalhesAgendado: state => {
    return state.DetalhesAgendado;
  },
  loadingWppMessagesList: state => {
    return state.loadingWppMessagesList;
  },
  pagingWhatsapp: state => {
    return state.pagingWhatsapp;
  },
  filtrosWhatsapp: state => {
    return state.filtrosWhatsapp;
  },
  filas: state => {
    return state.filas;
  },
  conexao: state => {
    return state.conexao;
  },
  tipoWhatsapp: state => {
    return state.tipoWhatsapp;
  },
  canalDourasat: state => {
    return state.canalDourasat;
  },
  configWhatsappCarregada: state => {
    return state.configWhatsappCarregada;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
